import React from 'react';
import { Stack, Link, Text, ITextStyles, ILinkStyles, useTheme } from '@fluentui/react';

const AppFooter: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  const textStyles: ITextStyles = {
    root: {
      marginRight: 10,
      fontWeight: 'bold',
      color: theme.palette.neutralPrimary,
    },
  };
  const linkStyles: ILinkStyles = {
    root: {
      color: theme.semanticColors.link,
      textDecoration: 'none',
      ':hover': {
        color: theme.semanticColors.linkHovered,
        textDecoration: 'underline',
      },
    },
  };

  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      verticalAlign="center" 
    >
      <Text variant="small" styles={textStyles}>&copy; {currentYear} Microsoft</Text>
      <Stack horizontal tokens={{ childrenGap: 10 }}>
        <Link href="https://go.microsoft.com/fwlink/?LinkId=518021" styles={linkStyles} target="_blank">Microsoft Data Privacy Notice</Link>
      </Stack>
    </Stack>
  );
};

export default AppFooter;
